var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loadingImportErrors),expression:"loadingImportErrors"}],staticClass:"import",attrs:{"id":"import"}},[(!_vm.loadingImportErrors)?_c('ErrorResolutionTable'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }